module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "mt-3"
  }, [_vm._v("Booking Question")]), _vm._v(" "), _c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-sm-10"
  }, [_c('label', {
    staticClass: "full"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getSelectedEvent.bookingQuestion),
      expression: "getSelectedEvent.bookingQuestion"
    }],
    attrs: {
      "type": "text",
      "placeholder": "e.g. Do you have the required fishing license?"
    },
    domProps: {
      "value": (_vm.getSelectedEvent.bookingQuestion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.getSelectedEvent, "bookingQuestion", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fs-smaller normal mt-2"
  }, [_vm._v("Use this if you want to add a question to the booking process.")])]), _vm._v(" "), _c('checkbox', {
    model: {
      value: (_vm.getSelectedEvent.bookingQuestionIsActive),
      callback: function($$v) {
        _vm.$set(_vm.getSelectedEvent, "bookingQuestionIsActive", $$v)
      },
      expression: "getSelectedEvent.bookingQuestionIsActive"
    }
  }, [_vm._v("\n                Is question active.\n            ")]), _vm._v(" "), _c('checkbox', {
    model: {
      value: (_vm.getSelectedEvent.bookingQuestionIsMandatory),
      callback: function($$v) {
        _vm.$set(_vm.getSelectedEvent, "bookingQuestionIsMandatory", $$v)
      },
      expression: "getSelectedEvent.bookingQuestionIsMandatory"
    }
  }, [_vm._v("\n                Is question mandatory.\n            ")])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-2cc8de51", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cc8de51"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/EventEdit/areaBookingQuestion.vue
// module id = 944
// module chunks = 0